import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select, { components } from "react-select";
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import idly from '../../../../images/items/items.jpg';
import axios from 'axios';
import { toast } from 'react-toastify';

const AddRawMaterial = ({ show, onClose, data, onSuccess }) => {
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [rawMaterial, setRawMaterial] = useState([]);

    useEffect(() => {
        if (data && data.raw_material) {
            setRawMaterial(data.raw_material);
        }
    }, [data]);

    const onInit = () => {

    };
    const [unitOptions, setUnitOptions] = useState([]);
    const [selectedUnit, setSelectedUnit] = useState(null);

    const fetchUnitsByCategory = async (categorySno, setOptions) => {
        try {
            const response = await axios.get(`${baseURL}/manageunit/by-category`, {
                params: { unit_category_sno: categorySno },
            });

            if (response.data.success) {
                const options = response.data.data.map(unit => ({
                    value: unit.unit_name,               // or unit.unit_name if needed
                    label: unit.unitslug_name,
                }));
                setOptions(options);
            }
        } catch (error) {
            console.error('Error fetching units by category:', error);
            setOptions([]);
        }
    };


    useEffect(() => {
        fetchUnitsByCategory(1, setUnitOptions); // 4 is unit_category_sno for item_quantity
    }, [baseURL]);

    const [rawMatrial, setRawMatrial] = useState([{ id: Date.now() }]);
    const [groupedOptions, setGroupedOptions] = useState([]);

    useEffect(() => {
        console.warn("rm: ", rawMatrial);
    }, [rawMatrial]);

    useEffect(() => {
        console.warn("data : ", data);
    }, [data]);

    useEffect(() => {
        axios.get(`${baseURL}/raw-material-categories-with-materials`)
            .then(response => {
                const categories = response.data.data;

                // Map API data to react-select grouped options format
                const formattedOptions = categories.map(category => ({
                    label: category.category_name,
                    options: category.raw_materials.map(material => ({
                        value: material.sno,
                        label: material.rawmaterial_name,
                        image_url: material.image_url,
                        brand: material.brand_name,
                        wastage: material.raw_material_wastage || '', // <-- add wastage
                        yield: material.yield || '',                  // <-- add yield
                    })),
                }));

                setGroupedOptions(formattedOptions);
            })
            .catch(error => {
                console.error('Error fetching raw material categories:', error);
            });
    }, [baseURL]);


    const Group = (props) => (
        <div style={customStyles}>
            <components.Group {...props} />
        </div>
    );
    const customStyles = {
        groupHeading: (provided) => ({
            ...provided,
            fontSize: '14px',  // Increase the font size for group labels
            fontWeight: 'bold',  // Optional: make the label bold
            color: '#333',  // Optional: change the text color
        }),
    };
    const [isVisible, setIsVisible] = useState({
        receipe_notes: false,
    });
    const toggleDiv = (section) => {
        setIsVisible((prev) => ({
            ...prev,
            [section]: !prev[section],
        }));
    };

    const handleAddConfig = () => {
        setRawMatrial(prev => [
            ...prev,
            {
                id: Date.now(),
                raw_material: null,
                quantity: '',
                unit: null,
            }
        ]);
    };

    const handleDeleteConfig = (id) => {
        setRawMatrial(prev => prev.filter(item => item.id !== id));
    };

    //view
    useEffect(() => {
        if (data && data.raw_material && data.raw_material.length > 0) {
            const mappedRawMatrial = data.raw_material.map(item => ({
                id: item.raw_material_id,  // must match your key/id in handleDeleteConfig
                raw_material: {
                    value: item.raw_material_id,
                    label: item.raw_material_name
                },
                quantity: item.quantity,
                unit: {
                    value: item.unit_id,
                    label: item.unit_name
                },
                wastage: item.wastage,  // ✅ include wastage
                yield: item.yield,
            }));
            setRawMatrial(mappedRawMatrial);
        } else {
            // If no raw materials, initialize with one empty entry
            setRawMatrial([{ id: Date.now(), raw_material: null, quantity: '', unit: null }]);
        }
    }, [data]);

    //post
    const handleSubmit = () => {
        // Basic front validation
        for (const mat of rawMatrial) {
            if (!mat.raw_material || !mat.unit || !mat.quantity) {
                alert('Please fill all fields: Raw Material, Quantity, and Unit');
                return;
            }
        }

        const payload = {
            raw_materials: rawMatrial.map(mat => ({
                raw_material: mat.raw_material.value,
                quantity: mat.quantity,
                unit: mat.unit.value,
            }))
        };

        // Now send payload to backend via axios/fetch...
        axios.post(`${baseURL}/manage-items/update-raw-materials/${data.sno}`, payload)
            .then(res => {
                // alert(res.data.message);

                toast.success("Raw Material Added Successfully!");
                if (onSuccess) onSuccess();
                onClose();

                // onClose();
            })
            .catch(err => {
                console.error(err);
                alert('Update failed!');
            });
    };


    const handleSaveRawMaterials = async () => {
        const errors = {};

        console.log(rawMatrial);
        
        rawMatrial.forEach((mat, index) => {
            if (!mat.raw_material) {
                errors[`raw_material_${index}`] = 'Raw Material is required';
            }
            if (!mat.quantity) {
                errors[`quantity_${index}`] = 'Quantity is required';
            }
            if (!mat.unit || !mat.unit.value) {
                errors[`unit_${index}`] = 'Unit is required';
            }
        });

        setValidationErrors(errors);

        // If there are any errors, stop submission
        if (Object.keys(errors).length > 0) return;


        const payload = {
            raw_materials: rawMatrial.map(mat => ({
                raw_material: mat.raw_material.value,
                quantity: mat.quantity,
                unit: mat.unit.value,
            })),
        };

        console.log(payload);

        try {
            const response = await axios.post(`${baseURL}/manage-items/update-raw-materials/${data.sno}`, payload);
            toast.success("Raw Material Updated Successfully!");
            if (onSuccess) onSuccess();
            onClose();
            // alert(response.data.message);
            // onClose();
        } catch (error) {
            console.error(error);
            alert('Update failed!');
        }
    };

    const [validationErrors, setValidationErrors] = useState({});

    return (
        <Modal show={show} size="lg">
            <div className="modal-content border border-red rounded-xxl">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Needed Raw Material</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={onClose}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-3">
                        <div className="col-lg-12">
                            <div className="d-flex align-items-center justify-content-start gap-2">
                                <LightGallery
                                    onInit={onInit}
                                    speed={500}
                                    plugins={[lgThumbnail, lgZoom]}
                                >
                                    <div data-src={data?.item_image || idly} className='border rounded px-1 py-0'>
                                        <img src={data?.item_image || idly} alt="Podi Idly" className='cursor-pointer w-60px h-60px' />
                                    </div>
                                </LightGallery>
                                <div className=''>
                                    <label className='text-black font-w400 fs-5'>{data?.item_name}</label>
                                    <label className='text-black me-2 ms-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>{data?.itemcategory_name}</label>
                                    <label className='text-black me-2 ms-2'>|</label>
                                    <label className='text-black font-w400 fs-5'>{data?.itemsubcategory_name}</label>
                                    <div className='d-block mt-1'>
                                        <label className='text-black font-w400 fs-7'>Quantity</label>
                                        <Badge bg="warning" className='text-white fs-7 py-0 px-1 ms-2 rounded-pill'>{data?.catering_corp_quantity} {data?.catering_corp_unit_slug_name ?? ''}</Badge>
                                    </div>
                                    {/* Total Wastage & Yield */}
                                    {/* Total Wastage & Yield */}
                                    {/* <div className="d-block mt-3">
                                        <label className="text-black font-w500 fs-7 me-3">
                                            Total Wastage: {data?.["total_wastage%"]
                                                ? Number(data["total_wastage%"]).toFixed(2)
                                                : "0.00"}%
                                        </label>
                                        <label className="text-black font-w500 fs-7">
                                            Total Yield: {data?.["total_yield%"]
                                                ? Number(data["total_yield%"]).toFixed(2)
                                                : "0.00"}%
                                        </label>
                                    </div> */}

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='scroll-y mh-350px py-2'>
                            <div className="col-lg-12">
                                <div className="mb-0">
                                    {rawMatrial.map((config, index) => (
                                        <div key={config.id} data-repeater-item>
                                            <div className="row">
                                                {/* Raw Material Select */}
                                                <div className="col-lg-6 mb-4">
                                                    <label className="text-black font-w500 fs-7">
                                                        Raw Material<span className="required">*</span>
                                                    </label>
                                                    
                                                    {/* Raw Material Select */}
                                                    <Select
                                                        placeholder="Select Raw Material"
                                                        value={config.raw_material}
                                                        onChange={(selectedOption) => {
                                                            const updated = [...rawMatrial];
                                                            updated[index].raw_material = selectedOption;
                                                            updated[index].wastage = selectedOption.wastage;
                                                            updated[index].yield = selectedOption.yield;
                                                            setRawMatrial(updated);
                                                        }}


                                                        options={groupedOptions}
                                                        components={{ Group }}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        menuPosition="fixed"
                                                    />

                                                    {validationErrors[`raw_material_${index}`] && (
                                                        <small className="text-danger">{validationErrors[`raw_material_${index}`]}</small>
                                                    )}
                                                </div>

                                                {/* Quantity Input */}
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">
                                                        Quantity <span className="required">*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Qty"
                                                        value={config.quantity || ''}
                                                        onChange={(e) => {
                                                            const updated = [...rawMatrial];
                                                            updated[index].quantity = e.target.value;
                                                            setRawMatrial(updated);
                                                        }}
                                                    />
                                                    {validationErrors[`quantity_${index}`] && (
                                                        <small className="text-danger">{validationErrors[`quantity_${index}`]}</small>
                                                    )}

                                                </div>

                                                {/* Unit Select */}
                                                <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">
                                                        Units<span className="required">*</span>
                                                    </label>

                                                    <Select
                                                        placeholder='Units'
                                                        value={config.unit}
                                                        onChange={(selectedOption) => {
                                                            const updated = [...rawMatrial];
                                                            updated[index].unit = selectedOption;
                                                            setRawMatrial(updated);
                                                        }}
                                                        options={unitOptions}
                                                        menuPlacement='top'
                                                        menuPosition='fixed'
                                                        menuPortalTarget={document.body}
                                                        styles={{
                                                            ...customStyles,
                                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                                        }}
                                                    />
                                                    {validationErrors[`unit_${index}`] && (
                                                        <small className="text-danger">{validationErrors[`unit_${index}`]}</small>
                                                    )}
                                                </div>

                                                {/* <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">
                                                        Wastage %
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Wastage %"
                                                        value={config.wastage ? Number(config.wastage).toFixed(2) : ''}
                                                        readOnly
                                                    />
                                                </div> */}

                                                {/* Yield Input (Read Only) */}
                                                {/* <div className='col-lg-2'>
                                                    <label className="text-black font-w500 fs-7">
                                                        Yield %
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Yield %"
                                                        value={config.yield ? Number(config.yield).toFixed(2) : ''}
                                                        readOnly
                                                    />
                                                </div> */}

                                                {/* Delete Button */}
                                                <div className="col-lg-1 mb-1 px-1 py-1">
                                                    {rawMatrial.length > 1 && (
                                                        <button
                                                            className="btn btn-danger mt-4 px-2 py-2"
                                                            onClick={() => handleDeleteConfig(config.id)}
                                                            data-bs-toggle="tooltip"
                                                            data-bs-placement="top"
                                                            title="Delete"
                                                        >
                                                            <i className="fa-solid fa-trash-can fs-6 mt-1 text-white"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="mb-1">
                            <button
                                className="btn btn-sm btn-primary"
                                onClick={handleAddConfig}
                            >
                                <span><i className="fa-solid fa-plus fs-6"></i></span>
                                <span className='ms-2 fs-7'>Add More</span>
                            </button>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4 mb-4">
                        <Link type="reset" className="btn btn-sm btn-secondary" onClick={onClose}>Cancel</Link>
                        {/* <Link type="submit" className="btn btn-sm btn-primary" onClick={onClose}>Needed Raw Material</Link> */}
                        <button type="button" className="btn btn-sm btn-primary" onClick={handleSaveRawMaterials}>Save Raw Materials</button>

                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default AddRawMaterial;
